import * as Yup from 'yup';

export const crisisAssessmentFormSchema = () => {
    const schema = Yup.object().shape({
        conclusion: Yup.string().required('This question is required'),
    });

    return schema;
}